export enum pendingPartsActions {
  GET_PENDING_PARTS_LOADING = "@@pendingParts/GET_PENDING_PARTS_LOADING",
  GET_PENDING_PARTS_SUCCESS = "@@pendingParts/GET_PENDING_PARTS_SUCCESS",
  GET_PENDING_PARTS_ERROR = "@@pendingParts/GET_PENDING_PARTS_ERROR",
}